import ChooseClasses from '../chooseClasses/ChooseClasses';
import { useBooking } from '../../../../../../contexts/ticketBookingContext/TicketBookingContext';
import BookingInfo from '../bookingInfo/BookingInfo';

export default function BookBookingTabItems() {
  const {
    departureClassesForm,
    returnClassesForm,
    bookingData,
  } = useBooking();
  const isReturnWay = Boolean(bookingData?.return?.id);
  return [
    {
      key: 1,
      children: <BookingInfo />,
    },
    {
      key: 2,
      children: <ChooseClasses
        direction="departure"
        bookClassesForm={departureClassesForm}
        typeBooking
      />,
    },
    {
      key: isReturnWay ? 3 : 100,
      children: <ChooseClasses
        direction="return"
        bookClassesForm={returnClassesForm}
        noAddress
      />,
    }];
}
